export default __webpack_public_path__ + "static/IBMPlexSans-Light-Latin2-d69d5111a1f16e74d2fb40dfcec48f30.woff2";